/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-param-reassign */
import {
	useCallback, useEffect, useState, useMemo,
} from "react";
import { END } from "redux-saga";
import { loadSelf } from "@fdn/profile_store";
import Env from "Consts/env";
import {
	Axios,
	updateCart,
	deleteCart,
	onCheckPromo,
	onApplyPromo,
	deleteOnePromo,
	updatePromo,
	copyTextToClipboard,
} from "Helpers/utils";
import Cookies from "js-cookie";
import * as ServerCookies from "cookies";
import { useRouter } from "next/router";
import dynamic from "next/dynamic";
import { useDispatch, useSelector } from "react-redux";
import vars from "Consts/vars";
import { handle498OnClient } from "Helpers/is498";
import { wrapper } from "@/Store/index";
import { loadCategoryDesktop } from "@/Store/category_desktop_store/lib/actions";
import { loadPromotionBrowse } from "@/Store/promotion_browse_store/lib/actions";
import { loadCartBadgeCount } from "@/Store/cart_badge_count_store/lib/actions";
import { loadCartTotal } from "@/Store/cart_total_store/lib/actions";

const Layout = dynamic(() => import("Containers/layout"));
const Mobile = dynamic(() => import("./mobile"));
const Desktop = dynamic(() => import("./desktop"));

const Cart = (props) => {

	const dispatch = useDispatch();
	const router = useRouter();
	const { query } = router;
	const data = props;
	const [showDrawer, setShowDrawer] = useState({
		promotion: false,
		detailPromotion: false,
	});
	const [cartData, setCartData] = useState(null);
	const [cartTotal, setCartTotal] = useState({});
	const [isLoading, setIsLoading] = useState({
		full: true,
		cart: false,
		promo: false,
		loader: false,
		orderSummary: false,
	});
	const [selectAll, setSelectAll] = useState(false);
	const [promo, setPromo] = useState([]);
	const [promotionDetail, setPromotionDetail] = useState(null);
	const [popupShow, setPopupShow] = useState({
		show: false,
		color: "",
		message: "",
		withOk: false,
	});
	const [promoErrMsg, setPromoErrMsg] = useState("");
	const [multiCoupons, setMultiCoupons] = useState([]);

	const defaultPromo = useSelector((state) => (state.storePromotionsBrowse.data?.data));
	const defaultSelectedPromo = useSelector((state) => (
		state.storePromotionsBrowse?.data?.selected_data));

	const isLoadingPromo = useSelector((state) => !(state.storePromotionsBrowse.status
		.includes(
			vars.FETCH_RESULT,
		) || state.storePromotionsBrowse.status
		.includes(
			vars.FETCH_ERROR,
		)));

	const authorization = Cookies.get("token") || null;
	const quoteId = Cookies.get("quoteId") || null;

	const dispatchPromotionBrowse = useCallback(
		() => dispatch(
			loadPromotionBrowse({ quoteId, authorization }),
		),
		[],
	);

	const handleSetLoading = (key, val) => setIsLoading((prev) => ({ ...prev, [key]: val }));

	const { getCartTotal, appliedCouponCode } = useSelector((state) => {

		if (state.storeCartTotals.status
			.includes(
				vars.FETCH_RESULT,
			) || state.storeCartTotals.status
			.includes(
				vars.FETCH_ERROR,
			)) {

			const couponCode = state.storeCartTotals.data.data?.coupon_codes || [];
			return {
				getCartTotal: state.storeCartTotals.data.data,
				appliedCouponCode: (couponCode.length > 0
					? couponCode.map((item) => (item.toUpperCase())) : []),
			};

		}
		return { getCartTotal: {}, appliedCouponCode: [] };

	});

	const isLoadCartTotal = useSelector((state) => !(state.storeCartTotals.status
		.includes(
			vars.FETCH_RESULT,
		) || state.storeCartTotals.status
		.includes(
			vars.FETCH_ERROR,
		)));

	const getMergeCart = useSelector((state) => (state.storeMergeCart.data));

	const mapFetchDataCart = (res) => {

		let list = [];
		if (res?.data?.length > 0) {

			list = res.data;

			if (query && query.product) {

				list = res?.data.map((item) => {

					if (item.extension_attributes.slug === query.product) {

						return { ...item, selected: !item.selected };

					}
					return item;

				});

			}

		}

		return list;

	};

	const handleUpdatePromo = () => {

		setMultiCoupons(defaultSelectedPromo);
		updatePromo(defaultPromo, setPromo, defaultSelectedPromo);

	};

	async function fetchDataCart() {

		const { data: resCart } = await Axios({
			method: "GET",
			url: `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api/fds-cart/items`,
		});

		dispatch(handle498OnClient(resCart));

		const list = mapFetchDataCart(resCart);

		setCartData(list);
		dispatch(loadCartTotal());
		isLoading.full && handleSetLoading("full", false);

	}

	const isResStatusOK = (code) => code >= 200 && code < 300;

	const toggleDone = (id) => {

		const updatedList =			cartData
			&& cartData.map((item) => {

				if (item.item_id === id) {

					return { ...item, selected: !item.selected };

				}
				return item;

			});

		setCartData(updatedList);

	};

	const toggleAllDone = () => {

		const updatedList =			cartData
			&& cartData.map((item) => {

				if (selectAll) {

					return { ...item, selected: false };

				}

				return { ...item, selected: true };

			});
		setCartData(updatedList);
		setSelectAll((curr) => !curr);

	};

	const toggleDelete = (id) => {

		const updatedList = cartData.filter((arr) => arr.item_id !== id);

		handleSetLoading("loader", true);

		setCartData(updatedList);
		deleteCart({
			id,
		}, dispatch)
			.then((res) => {

				if (res && res.status >= 200 && res.status < 300 && res.data) {

					dispatch(loadCartTotal());
					dispatch(loadCartBadgeCount());

				} else {

					console.log("Error");
					handleSetLoading("loader", false);

				}

			})
			.catch((err) => {

				console.log(`Error: ${err}`);

			}).finally(() => {

				handleSetLoading("loader", false);

			});

	};

	const toggleAmount = (id, item, type) => {

		handleSetLoading("loader", true);

		let requestedQty = item.qty;
		if (type === "plus") {

			requestedQty += 1;

		} else if (type === "minus") {

			requestedQty -= 1;

		}

		const detail =	cartData?.find((cartItem) => cartItem.item_id === id);

		let typeProduct = {};
		// If current cart quantity is more than max quantity,
		// set qty to the latest max qty of this item from cartData

		if (requestedQty > detail.extension_attributes.max_qty) {

			typeProduct = {
				simple: {
					qty: detail.extension_attributes.max_qty,
				},
				configurable: {
					qty: detail.extension_attributes.max_qty,
					product_option: detail.product_option,
					extension_attributes: {},
				},
			};

		} else {

			typeProduct = {
				simple: {
					qty: requestedQty,
				},
				configurable: {
					qty: requestedQty,
					product_option: item.product_option,
					extension_attributes: {},
				},
			};

		}

		updateCart({
			id,
			data: typeProduct[
				item?.product_type === "virtual"
					? "simple"
					: item.product_type
			],
		}, dispatch)
			.then((res) => {

				dispatch(handle498OnClient(res?.data));
				if (isResStatusOK(res?.data.meta.code)) {

					dispatch(loadCartTotal());
					dispatch(loadCartBadgeCount());

					if (requestedQty > detail.extension_attributes.max_qty) {

						setPopupShow({
							color: "#FF4D4F!important",
							show: true,
							message: "Your requested quantity exceeds available stock and now has been adjusted to available stock.",
							withOk: false,
						});

					}

					const updatedList =	cartData?.map((cartItem) => {

						if (cartItem.item_id === id) {

							return {
								...cartItem,
								qty: res.data.data.qty,
							};

						}
						return cartItem;

					});
					setCartData(updatedList);

				} else {

					setPopupShow({
						color: "#FF4D4F!important",
						show: true,
						message: res.data.meta.msg,
						withOk: false,
					});

				}

			})
			.catch((err) => {

				setPopupShow({
					color: "#FF4D4F!important",
					show: true,
					message: "Error update your quantity",
					withOk: false,
				});
				console.log(`Error: ${err}`);

			}).finally(() => {

				// dispatch(loadCartBadgeCount());
				handleSetLoading("loader", false);
				handleUpdatePromo();

			});

	};

	const choosePromo = async (item, type) => {

		if (type === "code") {

			let appliedCode = promo
				.filter((voucher) => voucher.selected)
				.map((voucher) => (
					voucher?.coupon
					&& voucher?.coupon.length > 0
					&& voucher?.coupon[0]
					&& voucher?.coupon[0].code
				));

			if ((appliedCouponCode.length > 0 || !appliedCode?.includes(item)) && item !== null && item !== "") {

				appliedCode = [...(appliedCouponCode || appliedCode), item];

			}

			await onApplyPromo({
				item: appliedCode,
				fetchCart: () => fetchDataCart(),
				setLoading: (value) => handleSetLoading("loader", value),
				showDrawer,
				setShowDrawer,
				setPopupShow,
				setPromoErrMsg,
				dispatch,
			});

			handleUpdatePromo();

		} else {

			onCheckPromo({
				item,
				promo,
				setPromo,
				multiCoupons,
				setMultiCoupons,
			});

		}

	};

	const buyNowCheckedItem = () => {

		if (query && query.product) {

			const updatedList =	cartData
				&& cartData.map((item) => {

					if (item.extension_attributes.slug === query.product) {

						return { ...item, selected: !item.selected };

					}
					return item;

				});

			setCartData(updatedList);

		}

	};

	const clearPromo = async (item, code) => {

		if (code === "code") {

			deleteOnePromo({
				item,
				setLoading: (value) => handleSetLoading("loader", value),
				showDrawer,
				setShowDrawer,
				setPopupShow,
				setPromoErrMsg,
				fetchCart: () => fetchDataCart(),
				dispatch,
			});

		}
		handleUpdatePromo();

	};

	const DirectToCheckout = () => {

		setPopupShow({
			color: "",
			show: false,
			message: "",
			withOk: false,
		});

		const validate = async () => {

			const resCart = await Axios({
				method: "GET",
				url: `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api/fds-cart/validate`,
			});

			return resCart;

		};

		const fetchDataCartRedirect = async () => {

			const { data: resCart } = await Axios({
				method: "GET",
				url: `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api/fds-cart/items`,
			});

			dispatch(handle498OnClient(resCart));
			const list = mapFetchDataCart(resCart);

			setCartData(list);
			dispatch(loadCartTotal());

		};

		handleSetLoading("loader", true);

		if (data?.getStoreSelf?.data.id) {

			validate().then((res) => {

				dispatch(handle498OnClient(res.data));
				if (isResStatusOK(res.data.meta?.code)) {

					if (res.data.data?.is_valid) {

						handleSetLoading("loader", false);
						window.location.href = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/checkout`;

					} else {

						fetchDataCartRedirect().then(() => {

							handleSetLoading("loader", false);

							setPopupShow({
								color: "#FF4D4F",
								show: true,
								message: "Sorry, there is an out of stock product!",
								withOk: false,
							});

						});

					}

				} else {

					handleSetLoading("loader", false);

					setPopupShow({
						color: "#FF4D4F",
						show: true,
						message: "Something went wrong, please try again later.",
						withOk: true,
					});

				}

			});

		} else {

			const pageReferer = window.location.href;
			window.location.href = `${process.env.NEXT_PUBLIC_SSO_DEV_DOMAIN || process.env.NEXT_PUBLIC_SSO_DOMAIN}/?url=${pageReferer}`;

		}

	};

	const HandleCopyText = (promoCode) => {

		setPopupShow({
			message: "",
			show: false,
			withOk: false,
		});

		copyTextToClipboard(promoCode);

		setPopupShow({
			message: "Code copied!",
			show: true,
			withOk: false,
		});

	};

	useEffect(() => {

		!isLoadCartTotal && setCartTotal(getCartTotal);
		handleSetLoading("cart", isLoadCartTotal);

	}, [isLoadCartTotal, getCartTotal]);

	useEffect(() => {

		handleSetLoading("promo", isLoadingPromo);

	}, [isLoadingPromo]);

	useEffect(() => {

		// update promo condition at first load
		handleUpdatePromo();

	}, [defaultPromo, defaultSelectedPromo]);

	useEffect(() => {

		const userId = Cookies.get("user_id") || null;
		if (!authorization && !quoteId && !userId) {

			setCartData([]);

		}
		if ((!authorization && quoteId)) {

			fetchDataCart();

		} else if (authorization && (JSON.stringify(getMergeCart) !== "{}") && quoteId) {

			fetchDataCart();

		} else if (authorization && !quoteId) {

			fetchDataCart();

		} else {

			isLoading?.full && handleSetLoading("full", false);

		}

	}, [getMergeCart?.data]);

	useEffect(() => {

		buyNowCheckedItem();

	}, []);

	useEffect(() => {

		if (showDrawer.promotion) {

			dispatchPromotionBrowse();

		}

	}, [showDrawer.promotion]);

	const isOnlyVirtualProduct = useMemo(() => !(cartData?.map((item) => (item?.product_type === "virtual"))?.includes(false)), [cartData]);
	const filteredPromo = promo?.filter((item) => item.is_published);

	return (
		<Layout
			home
			title="Femaledaily"
			titleNavbar="My Cart"
			metaTitle="My Cart"
			ismobile={data.isMobile}
			self={data.getStoreSelf}
			categoryDesktop={data && data.storeCategoryDesktop}
			getQuoteIdErrMessage={data.getQuoteIdErrMessage}
		>
			{
				data.isMobile
					? (
						<Mobile
							isOnlyVirtualProduct={isOnlyVirtualProduct}
							cartData={cartData}
							cartTotal={cartTotal}
							selectAll={selectAll}
							handleToggleAllDone={toggleAllDone}
							handleToggleDone={(val) => toggleDone(val)}
							handleToggleAmount={toggleAmount}
							handleToggleDelete={toggleDelete}
							promo={filteredPromo}
							appliedPromo={appliedCouponCode}
							handleChoosePromo={choosePromo}
							handleClearPromo={clearPromo}
							showDrawer={showDrawer}
							handleShowDrawer={(key, val) => setShowDrawer((prev) => ({ ...prev, [key]: val }))}
							directToCheckout={DirectToCheckout}
							promotionDetail={promotionDetail}
							setPromotionDetail={(val) => setPromotionDetail(val)}
							HandleCopyText={(val) => HandleCopyText(val)}
							// isLoadingCounter={isLoadingCounter}
							isLoading={isLoading}
							promoErrMsg={promoErrMsg}
							popupShow={popupShow}
							setPopupShow={(val) => setPopupShow(val)}
						/>
					)
					: (
						<Desktop
							isOnlyVirtualProduct={isOnlyVirtualProduct}
							isLoading={isLoading}
							cartData={cartData}
							cartTotal={cartTotal}
							selectAll={selectAll}
							handleToggleAllDone={toggleAllDone}
							handleToggleDone={(val) => toggleDone(val)}
							handleToggleAmount={toggleAmount}
							handleToggleDelete={toggleDelete}
							promo={filteredPromo}
							appliedPromo={appliedCouponCode}
							handleChoosePromo={choosePromo}
							handleClearPromo={clearPromo}
							showDrawer={showDrawer}
							handleShowDrawer={(key, val) => setShowDrawer((prev) => ({ ...prev, [key]: val }))}
							directToCheckout={DirectToCheckout}
							promotionDetail={promotionDetail}
							setPromotionDetail={(val) => setPromotionDetail(val)}
							HandleCopyText={(val) => HandleCopyText(val)}
							// isLoadingCounter={isLoadingCounter}
							popupShow={popupShow}
							setPopupShow={(val) => setPopupShow(val)}
							promoErrMsg={promoErrMsg}
						/>
					)
			}
		</Layout>
	);

};

export const getServerSideProps = wrapper.getServerSideProps(
	async ({
		store, req, res: resServer, query,
	}) => {

		const userAgent = req.headers["user-agent"];
		let authorization = null;
		let usrname = null;

		const isMobile = Boolean(
			userAgent.match(
				/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i,
			),
		);

		const isServer = !!req;

		const Cookie = new ServerCookies(req, resServer);

		if (req.headers.cookie) {

			authorization = Cookie.get("token");
			usrname = Cookie.get("usrname");

		}

		await store.dispatch(
			loadSelf({
				payload: {
					api_env: process.env.NEXT_PUBLIC_NODE_ENV,
					env: Env.HEADERS,
					usrname,
					Authorization: authorization,
					is_server: isServer,
				},
			}),
		);

		await store.dispatch(
			loadCategoryDesktop({
				payload: {},
			}),
		);

		store.dispatch(END);
		await store.sagaTask.toPromise();

		const categoryNavigationDesktop = [];
		const brands = {
			id: 200,
			name: "Brands",
			slug: "brands",
			items: [],
		};

		const getStoreSelf = !!store.getState().storeSelf.data === true
			? store.getState().storeSelf
			: [];

		const getStoreCategoryDesktop =	store?.getState()?.storeCategoryDesktop?.data;

		getStoreCategoryDesktop?.data && getStoreCategoryDesktop?.data.length > 0
		&& getStoreCategoryDesktop?.data[0]?.children_data
			.filter((val) => val.include_in_menu === "1")
			.map((item) => {

				categoryNavigationDesktop.push({
					id: item.entity_id,
					name: item.category_name,
					slug: item.category_path,
					items:
							item.children_data.length > 0
								? item.children_data.map((child) => ({
									id: child.entity_id,
									name: child.category_name,
									slug: child.category_path,
									items:
											child.children_data.length > 0
												? child.children_data.map(
													(childs) => ({
														id: childs.entity_id,
														name: childs.category_name,
														slug: childs.category_path,
														items:
																childs
																	.children_data
																	.length > 0
																	? childs.children_data.map(
																		(
																			lastChilds,
																		) => ({
																			id: lastChilds.entity_id,
																			name: lastChilds.category_name,
																			slug: lastChilds.category_path,
																		}),
																	)
																	: [],
													}),
												)
												: [],
								}))
								: [],
				});

			});
		categoryNavigationDesktop.splice(1, 0, brands);

		return {
			props: {
				query,
				isMobile,
				getStoreSelf,
				storeCategoryDesktop: categoryNavigationDesktop,
				getQuoteIdErrMessage: null,
			}, // will be passed to the page component as props
		};

	},
);

export default Cart;
